import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { collection, addDoc, setDoc } from 'firebase/firestore';

const AddPermissionModal = ({ show, handleClose, handleSave }) => {
    const [nom, setNom] = useState('');
    const [description, setDescription] = useState('');
    const [active, setActive] = useState(true);

    const handleAdd = async () => {
        try {
            // Create the new permission object with a placeholder ID
            const newPermission = { nom, description, active };
    
            // Add the new permission to Firestore
            const permissionsCollection = collection(db, 'permissions');
            const docRef = await addDoc(permissionsCollection, newPermission);
    
            // Update the permission object with the document ID
            const permissionWithId = { id: docRef.id, nom, description, active };
    
            // Replace the document with the updated data containing the ID
            await setDoc(docRef, permissionWithId);
    
            // Use handleSave to process the permission with the ID
            handleSave(permissionWithId);
    
            // Optionally close the form or reset state
            handleClose();
        } catch (error) {
            console.error("Error adding permission: ", error);
            // Optionally, handle error state or display an error message
        }
    };
    
    

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Ajouter une permission</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="formDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>
                    <br/>
                    <Form.Group controlId="formActive">
                        <Form.Check
                            type="checkbox"
                            label="Activé"
                            checked={active}
                            onChange={(e) => setActive(e.target.checked)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleAdd}>
                    Ajouter
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddPermissionModal;
